<template>
  <div>
    <v-dialog v-model="dialog" @keydown.esc="dialog = false" max-width="1080px">
      <v-card>
        <v-form ref="form" lazy-validation>
          <v-card-title>
            <span class="headline"
              >{{ $t("endpoint") }} {{ $t("information") }}
            </span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  name="input-7-1"
                  label="Default style"
                  :value="JSON.stringify(endpointItem, null, 4)"
                ></v-textarea>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="informationItems"
                  :items-per-page="-1"
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn color="primary" text @click="dialog = false">
              {{ $t("close") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "SystemEndpointInfoDialog",
  data() {
    return {
      dialog: false,
      headers: [
        { text: "key", value: "key" },
        { text: "type", value: "type" },
        { text: "content", value: "content" },
      ],
      endpointItem: {
        channel_uuid: "channel_uuid",
        camera_id: "camera_id",
        camera_name: "camera_name",
        camera_alias: "camera_alias",
        snapshot: "base64_encode_Image",
        license_plate: "ABC-1234",
        coordinate: {
          top: {
            x: 0.26,
            y: 0.15,
          },
          bottom: {
            x: 0.34,
            y: 0.22,
          },
        },
        timestamp: 1634720819482,
        list_type: "whitelist",
        plate_type: "normal",
        main_file: {
          license_plate: "ABC-1234",
          channel_uuid: "CH-1",
          list_type: "whitelist",
          area: "廠區1",
          chinese_name: "王",
          english_name: "Wang",
          company: "公司",
          department: "部門",
          employee_number: "A123",
          parking_space_number: "056",
          ID_number: "A123456789",
          phone: "0912345678",
          address: "地址",
          time_period: "早上 09:00~12:00",
          parking_type: "month",
          extra_field_1: "備註1",
          extra_field_2: "備註2",
          extra_field_3: "備註3",
        },
      },
      informationItems: [
        {
          key: "channel_uuid",
          type: "String",
          content: this.$t("content_channel_uuid"),
        },
        {
          key: "camera_id",
          type: "String",
          content: this.$t("content_camera_id"),
        },
        {
          key: "camera_name",
          type: "String",
          content: this.$t("content_camera_name"),
        },
        {
          key: "camera_alias",
          type: "String",
          content: this.$t("content_camera_alias"),
        },
        {
          key: "snapshot",
          type: "String",
          content: this.$t("content_snapshot"),
        },
        {
          key: "license_plate",
          type: "String",
          content: this.$t("content_license_plate"),
        },
        {
          key: "coordinate",
          type: "Dict",
          content: this.$t("content_coordinate"),
        },
        {
          key: "timestamp",
          type: "Int",
          content: this.$t("content_timestamp"),
        },
        {
          key: "list_type",
          type: "String",
          content: this.$t("content_list_type"),
        },
        {
          key: "plate_type",
          type: "String",
          content: this.$t("content_plate_type"),
        },
        {
          key: "main_file",
          type: "Dict",
          content: this.$t("content_main_file"),
        },
        //Mainfile's data
        {
          key: "license_plate",
          type: "String",
          content: this.$t("content_license_plate"),
        },
        {
          key: "channel_uuid",
          type: "String",
          content: this.$t("content_channel_uuid"),
        },
        {
          key: "list_type",
          type: "String",
          content: this.$t("content_list_type"),
        },
        {
          key: "area",
          type: "String",
          content: this.$t("content_area"),
        },
        {
          key: "chinese_name",
          type: "String",
          content: this.$t("content_chinese_name"),
        },
        {
          key: "english_name",
          type: "String",
          content: this.$t("content_english_name"),
        },
        {
          key: "department",
          type: "String",
          content: this.$t("content_department"),
        },
        {
          key: "employee_number",
          type: "String",
          content: this.$t("content_employee_number"),
        },
        {
          key: "parking_space_number",
          type: "String",
          content: this.$t("content_parking_space_number"),
        },
        {
          key: "ID_number",
          type: "String",
          content: this.$t("content_ID_number"),
        },
        {
          key: "phone",
          type: "String",
          content: this.$t("content_phone"),
        },
        {
          key: "address",
          type: "String",
          content: this.$t("content_address"),
        },
        {
          key: "time_period",
          type: "String",
          content: this.$t("content_time_period"),
        },
        {
          key: "parking_type",
          type: "String",
          content: this.$t("content_parking_type"),
        },
        {
          key: "extra_field_1",
          type: "String",
          content: this.$t("content_extra_field_1"),
        },
        {
          key: "extra_field_2",
          type: "String",
          content: this.$t("content_extra_field_2"),
        },
        {
          key: "extra_field_3",
          type: "String",
          content: this.$t("content_extra_field_3"),
        },
      ],
    };
  },
};
</script>
